class UserActivityException extends Error {
  isReportable = false
  constructor(message: string, isReportable = false) {
    super(message)
    this.isReportable = isReportable
  }
}

export default UserActivityException
